import { IconeHistorique } from '@/components/historique/icone-historique';
import { Button } from '@pms-digital/design-system';

interface EnteteResultatProps {
  /** Opens the choice of the noyaux to add to this text (#24, the window of the history, #11). */
  onAutreNoyau: () => void;
  /** Back to an empty input screen. */
  onNouveau: () => void;
}

/** Title of the result screen and its two buttons: the noyaux to add, a new text (#37: "modifier le texte" was removed). */
export function EnteteResultat({ onAutreNoyau, onNouveau }: EnteteResultatProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
      <h1 className="text-h2 leading-[1.2]">
        <span className="font-light">Votre texte</span> <span className="font-bold">traduit</span>
      </h1>
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="ghost" onClick={onAutreNoyau}>
          <IconeHistorique name="sync" size={20} />
          Traduire vers un autre noyau
        </Button>
        <Button type="button" variant="ghost" icon="add" onClick={onNouveau}>
          nouveau texte
        </Button>
      </div>
    </div>
  );
}
